module.exports = __webpack_public_path__ + "img/slide-without-wall.b0d437f8.png";